<template>
  <el-select
    v-model="val"
    class="inline"
    :size="size"
    :disabled="items.length < 2"
    @change="change"
  >
    <el-option 
      v-for="item in items" 
      :key="item.id" 
      :label="item.name" 
      :value="item.id"
    />
  </el-select>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "AProductUnitSelector",
  data() {
    return {
      val: null,
      options: []
    };
  },
  props: {
    // 제품 ID
    id: {
      type: Number,
    },
    value: {
      type: Number,
      default: 1,
    },
    size: {
      default: 'mini',
    },
    /**
     * 규격수량 비활성화 여부
     */
    disableSizeAmount: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_unit", "table_product"]),
    items: function() {
      if (!this.id) {
        this.applyValue(1);
        return this.table_unit.filter(u => u.id === 1);
      }
      let product = this.table_product.find(p => p.id === this.id);
      if (!product) {
        this.applyValue(1);
        return this.table_unit.filter(u => u.id === 1);
      }
      //규격 수량으로 설정된 품목은 EA로 표시
      if (!this.disableSizeAmount) {
        if (product.size_amount_flag === 'Y') {
          this.applyValue(1);
          return this.table_unit.filter(u => u.id === 1);
        }
      }
      let current = this.table_unit.find(u => u.id === product.unit_id);
      let items = [];
      if (current.source_id) {
        items = this.table_unit.filter(u => u.id === current.source_id || u.source_id === current.source_id);
      } else {
        items = this.table_unit.filter(u => u.source_id === current.id);
        items.push(current)
      }
      if (this.value) {
        let current2 = items.find(u => u.id === this.value);        
        if (current2) {
          current = current2;
        }
      }
      items.sort((a, b) => {
        return a.seq - b.seq;
      });     
      this.applyValue(current.id);
      return items;
    }
  },  
  mounted() {
    this.val = this.value;
  },
  methods: {
    change(val) {     
      this.val = val;
      this.$emit("input", val);
    },
    applyValue(val) {
      this.$nextTick(() => {
        this.change(val)
      })
    },
  }
};
</script>
